<template>
    <div>
        <select-as-radio-field
            v-model="hemophilia_type"
            :field="patientFields.hemophilia_type"
            :errors="errors"
            :inline="false"
            field-name="hemophilia_type"
            class="mb-3"
        />

        <input-field
            v-model="iti_year_eradication"
            :field="patientFields.iti_year_eradication"
            :errors="errors"
            field-name="iti_year_eradication"
            type="number"
            class="mb-3"
        />

        <checkbox-field
            v-model="has_family_history_inhibitors"
            :field="patientFields.has_family_history_inhibitors"
            :errors="errors"
            field-name="has_family_history_inhibitors"
            class="mb-3"
        />

        <select-as-radio-field
            v-model="usual_treatment"
            :field="patientFields.usual_treatment"
            :errors="errors"
            :inline="false"
            field-name="usual_treatment"
            class="mb-3"
            several
        />

        <select-as-radio-field
            v-model="infusion_number"
            :field="patientFields.infusion_number"
            :errors="errors"
            :inline="false"
            field-name="infusion_number"
            class="mb-3"
        />
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import {mapStateProperty} from "@/utils/VuexHelpers";
    import InputField from "@/components/fields/InputField";
    import CheckboxField from "@/components/fields/CheckboxField";
    import {required} from "vuelidate/lib/validators";
    import SelectAsRadioField from "@/components/fields/SelectAsRadioField";

    export default {
        name: "PatientDisease",
        components: {SelectAsRadioField, CheckboxField, InputField},
        computed: {
            ...mapState([
                'patientFields',
            ]),
            ...mapStateProperty([
                'patient.hemophilia_type',
                'patient.iti_year_eradication',
                'patient.has_family_history_inhibitors',
                'patient.usual_treatment',
                'patient.infusion_number',
            ]),
            errors() {
                let errors = {};
                if (this.$v.infusion_number.$error) {
                    errors['infusion_number']  = [this.$t('error.required')];
                }
                return errors;
            }
        },
        methods: {
            validate() {
                this.$v.$touch();
                return !this.$v.$invalid;
            },
            back() {
                return true;
            },
        },
        validations: {
            infusion_number: {
                required,
            }
        }
    };
</script>

<style scoped>

</style>